import React, { PureComponent } from "react";
import classNames from "../../utils/classnames";

export class PanelFooter extends PureComponent {
  render() {
    const { children, className, access, ...others } = this.props;
    const cls = classNames({
      "weui-panel__ft": true
    }, className);

    return (
      <div className={ cls } { ...others }>{ children }</div>
    );
  }
}
